import * as Typings from '../typings'
import { BRAND_LIST, Languages } from '../../typings'

const VietnamLocale: Typings.LocaleType = {
  REGION: Typings.RegionGroupNames.SOUTH_EAST_ASIA,
  CODE: 'vn',

  LONG_NAME: 'Vietnam',
  SHORT_NAME: 'VN',

  DISPLAY_COUNTRY: 'Vietnam',

  LANGUAGES: {
    EN: 'en',
    VI: 'vi',
  },

  [BRAND_LIST.UQ]: {
    [Languages.EN]: {
      LANGUAGE_CODE: 'en',
      DISPLAY_NAME: 'Vietnam (English)',
      TERMS_OF_USE_URL:
        'https://faq-vn.uniqlo.com/articles/en_US/FAQ/UQVN-TERMS-OF-USE',
      PRIVACY_POLICY_URL:
        'https://faq-vn.uniqlo.com/articles/en_US/FAQ/UQVN-Privacy-policy',
      HOME_PAGE_URL: 'https://uniqlo.com/vn/en/',
      CONTACT_US_URL: 'https://faq-vn.uniqlo.com/pkb_Home_UQ_VN?l=en_us',
    },
    [Languages.VI]: {
      LANGUAGE_CODE: 'vi',
      DISPLAY_NAME: 'Tiếng Việt',
      TERMS_OF_USE_URL:
        'https://faq-vn.uniqlo.com/articles/vi/FAQ/%C4%90i%E1%BB%81u-kho%E1%BA%A3n-s%E1%BB%AD-d%E1%BB%A5ng',
      PRIVACY_POLICY_URL:
        'https://faq-vn.uniqlo.com/articles/vi/FAQ/Ch%C3%ADnh-s%C3%A1ch-b%E1%BA%A3o-m%E1%BA%ADt',
      HOME_PAGE_URL: 'https://www.uniqlo.com/vn/vi/',
      CONTACT_US_URL: 'https://faq-vn.uniqlo.com',
    },
  },

  GEO_COORDINATES: {
    INITIAL_LATITUDE: 14.0583,
    INITIAL_LONGITUDE: 108.2772,
    INITIAL_ZOOM: 7,
    INITIAL_ZOOM_DETAILS_PAGE: 15,
  },

  MAP_URL: 'https://www.uniqlo.com/vn/shop/',
  // MAP_MOBILE_URL: '',

  POSTCODE_FORMAT: /[0-9]{6}/g,

  CLIENT_ID: {
    [BRAND_LIST.UQ]: '',
  },

  AM_FORMAT: ' AM',
  PM_FORMAT: ' PM',

  ONE_TRUST_FOOTER: {
    [BRAND_LIST.UQ]: true,
  },
  CMS_ENABLED: {
    [BRAND_LIST.UQ]: true,
  },
}

export default VietnamLocale
